import React from "react";
import Helmet from "react-helmet";

import HomeLayout from "../components/HomeLayout";

const Page = () => (
	<>
		<Helmet title="Your WOL" />
		<HomeLayout>
			<h1>Your WOL</h1>
		</HomeLayout>
	</>
);

export default Page;
